import { Component } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

export default class PerformanceCategoryComparisonChart extends Component {
  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    this.chart = new Highcharts.Chart({
      chart: {
        renderTo: this.chartContainer,
        type: "bar",
      },
      colors: [this.props.highlight_color, "#999"],
      title: {
        text: "",
      },
      legend: {
        align: "right",
        verticalAlign: "top",
        margin: 30,
        padding: 0,
        itemStyle: {
          color: "#333",
          fontSize: "14",
          fontWeight: "700",
        },
      },
      tooltip: {
        animation: false,
        backgroundColor: "#333",
        borderWidth: 0,
        borderRadius: 10,
        headerFormat: null,
        padding: 10,
        pointFormat: "{series.name}: <b>{point.y}</b>",
        valueSuffix: " ms",
        shared: true,
        shadow: false,
        style: {
          color: "#fff",
          fontSize: 14,
        },
      },
      xAxis: {
        title: {
          enabled: false,
        },
        type: "category",
        labels: {
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        tickmarkPlacement: "on",
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        tickInterval: 1,
        tickWidth: 0,
      },
      yAxis: {
        min: 0,
        title: {
          text: "90th-percentile time in milliseconds",
          style: {
            color: "#999",
            fontSize: "16",
            fontWeight: "700",
          },
        },
        labels: {
          step: 2,
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        gridLineWidth: 0,
        showLastLabel: false,
      },
      series: [
        {
          name: this.props.label,
          pointWidth: 12,
          data: _map(this.props.services, service => {
            return {
              name: service.name,
              y: (parseInt(service.time / 10, 10) + 1) * 10, // round to the nearest 10
              color:
                service.name == this.props.highlight_service
                  ? this.props.highlight_color
                  : "#999",
            }
          }),
        },
      ],
      plotOptions: {
        bar: {
          groupPadding: 0,
          pointPadding: 0,
          shadow: false,
        },
        series: {
          animation: false,
          states: {
            hover: {
              enabled: false,
            },
          },
          events: {
            legendItemClick: () => {
              return false
            },
          },
        },
      },
      credits: {
        enabled: false,
      },
    })
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return (
      <div className="chart-container" ref={c => (this.chartContainer = c)} />
    )
  }
}

PerformanceCategoryComparisonChart.propTypes = {
  highlight_service: PropTypes.string.isRequired,
  highlight_color: PropTypes.string.isRequired,
  services: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
}
